import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { RestartProgramPage } from './restart-program';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared';
import { translateConfig } from '../../config/translate.config';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    RestartProgramPage
  ],
  imports: [
    IonicModule,
    CommonModule,
    RouterModule.forChild([{ path: '', component: RestartProgramPage }]),
    TranslateModule.forChild(translateConfig),
    SharedModule
  ]
})
export class RestartProgramPageModule {}
